import {PLATFORM, bindable, containerless, customElement, useView} from 'aurelia-framework';
import {isGroupDefaultOrDummy} from '../../../../../services/group/group-service';
import {GroupViewHeader} from './view-header';

@containerless()
@useView(PLATFORM.moduleName('./view-header.html'))
@customElement('group-settings-view-header')
export class GroupSettingsViewHeader extends GroupViewHeader {

  atSettings = true;
  @bindable justCreated = false;
  @bindable groupData;

  handleLocation() {
    let globalAdmin = this.selectedGroup.isGlobalAdmin;
    if (!isGroupDefaultOrDummy(this.selectedGroup.id) && globalAdmin) {
      this.showSettings();
    } else {
      this.showApplication();
    }
  }

  bind() {
    super.bind();
    if (this.justCreated) {
      this.groupService.parentPath(this.groupData.id).response.then(path => {
        this.handleCurrentGroup({groupPath: path});
      });
    }
  }

}
